import React, { Component } from 'react'
import { Grid, Row, Col } from 'react-bootstrap'
import { Card } from 'element-react'
import axios from 'axios'
import { SERVER_URL } from '../constants'
import Form from './Form/Form'
import AboveForm from './AboveForm'

class Pridat extends Component {
  state = {
    imagesList: [],
    filesList: [],
    submitting: false,
    submitted: false,
    hasSubmitErrored: false,
  }

  handleFilesChange = isImage => (filename, fileList) => {
    const key = isImage ? 'imagesList' : 'filesList'
    this.setState({ [key]: fileList })
  }

  handleSubmitStart = () => {
    this.setState({ submitting: true })
  }

  showSubmitFail = () => {
    this.setState({
      hasSubmitErrored: true,
      submitting: false,
    })
  }

  handleSubmit = (formData, verificationCode) => {
    const url = `${SERVER_URL}/submit/post`
    const { imagesList, filesList } = this.state
    const images = imagesList.map(i => i.response)
    const files = filesList.map(f => f.response)
    const is89 = window.location.pathname.startsWith('/89')
    const data = {
      ...formData,
      images,
      files,
      verificationCode,
      is89,
    }

    axios
      .post(url, data)
      .then((res) => {
        if (res.status === 200) {
          this.setState({
            submitting: false,
            submitted: true,
          })
          localStorage.removeItem('spytajsavasich')
        }
      })
      .catch((error) => {
        if (window.Raven) {
          window.Raven.captureException(error, { extra: 'Pridat axios post catched error!' })
        }
        this.showSubmitFail()
      })
  }

  render() {
    const {
      filesList, imagesList, submitted, hasSubmitErrored,
    } = this.state

    return (
      <Grid className="Pridat">
        <Row>
          {!submitted && (
            <Col xs={12} md={8} mdPush={2} lg={6} lgPush={3}>
              <AboveForm />
              <Form
                imagesList={imagesList}
                filesList={filesList}
                onError={this.showSubmitFail}
                onFilesChange={this.handleFilesChange}
                onSubmitStart={this.handleSubmitStart}
                onSubmit={this.handleSubmit}
                onVerify={this.handleVerified}
                submitting={this.state.submitting}
                hasSubmitErrored={hasSubmitErrored}
              />
            </Col>
          )}

          {submitted && (
            <Col xs={12} md={8} mdPush={2} lg={6} lgPush={3}>
              <Card header={<h3>Ďakujeme!</h3>}>
                <p>Zaraďovanie príspevkov nie je automatické, preto chvíľku potrvá, kým sa ten váš objaví na stránke. Ďakujeme za pochopenie a trpezlivosť.</p>
                <p>Barbora, Pavlína, Eva</p>
              </Card>
            </Col>
          )}
        </Row>
      </Grid>
    )
  }
}

export default Pridat



// WEBPACK FOOTER //
// ./src/components/Pridat.js